
import cmBlank from '@/components/cmBlank.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
Datetime,cmBlank
},
data() {
return {
blankShow:false,
index:0,
dateStatus:false,
startDate:'',
endDate:'',
list:[]
}
},
created(){
this.setDate();
this.getList();
},
methods: {
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);
nowDate.setMonth(nowDate.getMonth()-1);
var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
getList() {
this.$func.startLoading();
this.$api.goodsCount({end:this.endDate,start:this.startDate}).then((res)=>{
if(res){
this.$func.endLoading();
this.list = res.data;
this.blankShow = res.data.length > 0 ? false : true;
}
})
},
download(){
this.$func.startLoading();
this.$api.goodsCountExport({end:this.endDate,start:this.startDate}).then((res)=>{
this.$func.endLoading();

window.open(res.data.path,'__self');
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/goodsCount.vue